import PropTypes from "prop-types";
import React from "react";
import { Row, Col, Alert, Card, CardBody, Container, FormFeedback, Input, Label, Form } from "reactstrap";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link } from "react-router-dom";
import withRouter from "../../../Components/Common/withRouter";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// action
import { forgetPassword } from "../../../utils/usermanagement";

// import images
// import profile from "../../assets/images/bg.png";
import { layoutModeTypes } from "../../../Components/constants/layout";
import logoDark from '../../../assets/images/exiaLogo_dark.png';
import logoLight from '../../../assets/images/exiaLogo_light.png';
import ParticlesAuth from "../../AuthenticationInner/ParticlesAuth";
import { createSelector } from "reselect";

const ForgetPasswordPage = props => {
  const dispatch = useDispatch();

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Please Enter Your Email"),
    }),
    onSubmit:async (values) => {
      
      try { 
        const response = await forgetPassword(values);
        // alert('values', values);
        if (response.success) { 
          props.router.navigate("/verification"); // Redirect to a protected page 
        } else if (response.code === 404) {
          alert(response.message);
          props.router.navigate("/register"); // Redirect to a protected page 
        } else {
            // setError(response.message);
            console.error("Error:",response.message);
        }
    } catch (err) {
        console.error('submit failed. Please try again.Error', err);
        // setError('Login failed. Please try again.');
    }
    }
  });

  const handleSubmit = async (values) => {
    try {  
      // Make API call with error handling
      const response = await forgetPassword(values);
      
      if (response.success) { 
        console.log('success', response.success)
        props.router.navigate("/verification"); // Redirect to a protected page 
      } else if (response.code === 404) {
        alert(response.message);
        props.router.navigate("/register"); // Redirect to a protected page 
      } else {
          // setError(response.message);
          alert(response.message);

          console.error("Error:",response.message);
      }
  
    } catch (err) {
      console.error('Submission failed:', err);
      
      // User-friendly error message
      alert(
        err.response?.message || 
        err.message || 
        'Failed to start password recovery. Please check your connection and try again.'
      );
    }
  };

  const selectLayoutState = (state) => state.ForgetPassword;
  const selectLayoutProperties = createSelector(
    selectLayoutState,
    (state) => ({
      forgetError: state.forgetError,
      forgetSuccessMsg: state.forgetSuccessMsg,
    })
  );
  // Inside your component
  const {
    forgetError, forgetSuccessMsg
  } = useSelector(selectLayoutProperties);

  // Get the current layout mode from Redux store
  const selectLayoutModeState = (state) => state.Layout;
  const layoutModeData = createSelector(
    selectLayoutModeState,
    (layout) => ({
      layoutModeType: layout.layoutModeType,
    })
  );
  const { layoutModeType } = useSelector(layoutModeData);

  // Use the actual layout mode from Redux instead of hardcoded logic
  const mode = layoutModeType || layoutModeTypes.LIGHTMODE;
  
  document.title="Reset Password | SeedNations";

  return (
    <ParticlesAuth>
      <div className="auth-page-content">
        <Container>
          <Row>
            <Col lg={12}>
              <div className="text-center mt-sm-5 mb-4 text-white-50">
                <div>
                  <Link to="/" className="d-inline-block auth-logo">
                  {/* Logo logic: Light mode shows light logo, Dark mode shows dark logo */}
                  <img src={mode === layoutModeTypes.LIGHTMODE ? logoLight : logoDark} alt="" height="200" />
                  </Link>
                </div> 
              </div>
            </Col>
          </Row>

          <Row className="justify-content-center">
            <Col md={8} lg={6} xl={5}>
              <div className="mt-4">

                <div className="p-4">
                  <div className="text-center mt-2">
                    <h5 className="text-primary">Forgot Password?</h5>
                    <p className="text-muted">Reset password with SeedNations</p>

                    <lord-icon
                      src="https://cdn.lordicon.com/rhvddzym.json"
                      trigger="loop"
                      colors="primary:#00bd9d"
                      className="avatar-xl"
                      style={{ width: "120px", height: "120px" }}
                      >
                    </lord-icon>

                  </div>

                  <Alert className="border-0 alert-warning text-center mb-2 mx-2" role="alert" timeout={300}>
                    Enter your email and instructions will be sent to you!
                  </Alert>
                  <div className="p-2">
                    {forgetError && forgetError ? (
                      <Alert color="danger" style={{ marginTop: "13px" }}>
                        {forgetError}
                      </Alert>
                    ) : null}
                    {forgetSuccessMsg ? (
                      <Alert color="success" style={{ marginTop: "13px" }}>
                        {forgetSuccessMsg}
                      </Alert>
                    ) : null}
                    <Form
                      onSubmit={(e) => {
                        e.preventDefault();
                        console.log(validation.values);
                        handleSubmit(validation.values);
                        return false;
                      }}
                    >
                      <div className="mb-4">
                        <Label className="form-label">Email</Label>
                        <Input
                          name="email"
                          className="form-control"
                          placeholder="Enter email"
                          type="email"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.email || ""}
                          invalid={
                            validation.touched.email && validation.errors.email ? true : false
                          }
                        />
                        {validation.touched.email && validation.errors.email ? (
                          <FormFeedback type="invalid"><div>{validation.errors.email}</div></FormFeedback>
                        ) : null}
                      </div>

                      <div className="text-center mt-4">
                        <button className="btn  w-100"  style={{backgroundColor:'#24F4C0',color:'#000'}} type="submit">Send Reset Link</button>
                      </div>
                    </Form>
                  </div>
                </div>
              </div>

              <div className="mt-4 text-center">
                <p className="mb-0">Wait, I remember my password... <Link to="/login" className="fw-semibold text-primary text-decoration-underline"> Click here </Link> </p>
              </div>

            </Col>
          </Row>
        </Container>
      </div>
    </ParticlesAuth>
  );
};

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);
